import { BehaviorSubject, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';

import { ApiResponsePropertyConfig } from '../../interfaces/api-response-property-config.interface';
import { SecurityService } from '../../services/security/security.service';

@Injectable()
export class PropertyConfigService implements OnDestroy {
  data$ = new BehaviorSubject(null);
  unsubscribe$ = new Subject();

  constructor(private http: HttpClient, private securityService: SecurityService)  {
    this.getData();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getData(): void {
    this.http
      .get('/api/tsorder/system/property/config')
      .pipe(
        takeUntil(this.unsubscribe$),
        catchError(error => this.securityService.catchResponse(error))
      )
      .subscribe((data: ApiResponsePropertyConfig) => {
        this.data$.next(data);
      });
  }
}
